import {Component, ContentChildren, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-row-info-button',
  templateUrl: './row-info-button.component.html',
  styleUrls: ['./row-info-button.component.scss'],
})
export class RowInfoButtonComponent  implements OnInit {

  @ContentChildren('btnTmpl') btnTmpl;

  @Input() label:string;
  @Input() text:string;
  @Input() shoBorderBottom:boolean;

  constructor() { }

  ngOnInit() {}

}
